import { $$ } from 'utils/dom';
import Lightbox from 'modules/lightbox/Lightbox';

const textmediaImages = $$('.textmedia__image');

if (textmediaImages.length) {
  textmediaImages.forEach(image => {
    new Lightbox(image, {
      selector: '.lightbox-toggle',
    }).init();
  });
}
